import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = {
	auth: true
}

export default {
	path: '/order',
	name: 'order',
	meta,
	redirect: {
		name: 'order-index'
	},
	component: layoutHeaderAside,
	children: (pre => [
		{
			path: 'matchOrder',
			name: `${pre}match`,
			component: _import('order/matchOrder'),
			meta: {
				...meta,
				title: '匹配记录'
			}
		},
		{
			path: 'dateOrder',
			name: `${pre}date`,
			component: _import('order/dateOrder'),
			meta: {
				...meta,
				title: '约会记录'
			}
		},
		{
			path: 'feedback',
			name: `${pre}feedback`,
			component: _import('order/feedbackList'),
			meta: {
				...meta,
				title: '反馈列表'
			}
		},
	])('order-')
}